import { render } from "./CreateNetwork.vue?vue&type=template&id=3e39586e"
import script from "./CreateNetwork.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateNetwork.vue?vue&type=script&setup=true&lang=js"

import "./CreateNetwork.vue?vue&type=style&index=0&id=3e39586e&lang=scss"

import exportComponent from "../../../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/points/modals/CreateNetwork/CreateNetwork.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e39586e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e39586e', __exports__)) {
    api.reload('3e39586e', __exports__)
  }
  
  module.hot.accept("./CreateNetwork.vue?vue&type=template&id=3e39586e", () => {
    api.rerender('3e39586e', render)
  })

}


export default __exports__